var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingL1 = function SvgEarRingL1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 25,
    height: 36,
    viewBox: "0 0 0.53 0.77",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2315637404160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.44.14C.38.02.07-.01.06.27.05.44.05.55.25.59.26.59.28.6.3.6M.45.56C.46.55.47.54.47.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.21.25C.28.23.43.31.32.34.25.36.25.41.36.41.37.42.39.42.4.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.37.59C.29.65.41.74.44.64.45.61.42.6.4.59H.37zM.26.66C.25.61.27.56.33.52.35.51.37.5.4.5c.01.01.03.01.04.02h.01c.05.03.1.05.07.14C.5.73.46.76.41.77.37.77.34.76.31.74.28.72.26.69.26.66z",
    fill: "#000"
  })))));
};

export default SvgEarRingL1;